<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed ? 'logo-collapse-width' : 'logo-width'">
				<div class="logo-img">
					<img src="../assets/images/icon.png" alt="">
					<h1 v-if="!collapsed">{{ $t('pageTitle', 'home') }}</h1>
				</div>
			</el-col>
			<el-col :span="10">
				<div class="tools" @click.prevent="collapse">
					<i class="fa fa-align-justify"></i>
				</div>
			</el-col>
			<el-col :span="4" class="userinfo">
				<!-- 新增的下拉菜单按钮 -->
				<el-dropdown trigger="hover" class="header-dropdown">
					<el-button type="text" class="header-btn">
						<i class="el-icon-setting"></i>
						{{ getCurrentLanguageDisplayName() }}
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="switchLanguage('zh-CN')" :class="{ 'is-active': currentLanguage === 'zh-CN' }">
							<i class="el-icon-check" v-if="currentLanguage === 'zh-CN'"></i>
							简体中文
						</el-dropdown-item>
						<el-dropdown-item @click.native="switchLanguage('zh-TW')" :class="{ 'is-active': currentLanguage === 'zh-TW' }">
							<i class="el-icon-check" v-if="currentLanguage === 'zh-TW'"></i>
							繁體中文
						</el-dropdown-item>
						<el-dropdown-item @click.native="switchLanguage('en')" :class="{ 'is-active': currentLanguage === 'en' }">
							<i class="el-icon-check" v-if="currentLanguage === 'en'"></i>
							English
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				
				<!-- 原有的用户信息下拉菜单 -->
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"><img :src="this.sysUserAvatar" /> {{ sysUserName }}</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="logout">{{ currentTexts.logout }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed ? 'menu-collapsed' : 'menu-expanded'">
				<!--导航菜单-->
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose"
					@select="handleselect" unique-opened router v-show="!collapsed">
					<template v-for="(item, index) in $router.options.routes">
						<div v-if="!item.hidden" :key="index">
							<el-submenu :index="index + ''"
								v-if="!item.leaf && (item.path == '/' || menusPath.includes(item.path))">
								<template slot="title"><i :class="item.iconCls"></i>{{ getMenuName(item.name) }}</template>
								<template v-for="child in item.children">
									<el-menu-item v-if="!child.hidden && menusPath.includes(child.path)" :index="child.path"
										:key="child.path">
										{{ getMenuName(child.name) }}
									</el-menu-item>
								</template>
							</el-submenu>
							<el-menu-item
								v-if="item.leaf && item.children.length > 0 && menusPath.includes(item.children[0].path)"
								:index="item.children[0].path"><i :class="item.iconCls"></i>{{ getMenuName(item.children[0].name)
								}}</el-menu-item>
						</div>
					</template>
				</el-menu>
				<!--导航菜单-折叠后-->
				<ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
					<template v-for="(item, index) in $router.options.routes">
						<li v-if="!item.hidden" class="el-submenu item" :key="index">
							<template v-if="!item.leaf">
								<div class="el-submenu__title" style="padding-left: 20px;"
									@mouseover="showMenu(index, true)" @mouseout="showMenu(index, false)"><i
										:class="item.iconCls"></i></div>
								<ul class="el-menu submenu" :class="'submenu-hook-' + index"
									@mouseover="showMenu(index, true)" @mouseout="showMenu(index, false)">
									<template v-for="child in item.children">
										<li v-if="!child.hidden" :key="child.path" class="el-menu-item"
											style="padding-left: 40px;"
											:class="$route.path == child.path ? 'is-active' : ''"
											@click="$router.push(child.path)">
											{{ getMenuName(child.name) }}
										</li>
									</template>
								</ul>
							</template>
							<template v-else>
								<div class="el-submenu__title el-menu-item"
									style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;min-width: 60px;"
									:class="$route.path == item.children[0].path ? 'is-active' : ''"
									@click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
							</template>
						</li>
					</template>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<div class="title">{{ getMenuName($route.name) }}</div>
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ getMenuName(item.name) }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>
</template>

<script>
import { getLocalStorage, removeCookie, removeLocalStorage } from '@/utils/util.js'
import { serverUrl } from "@/utils/server.js";
import { i18nManager } from '@/utils/i18n';
import i18nMixin from '@/mixins/i18nMixin.js';

export default {
	mixins: [i18nMixin],
	data() {
		return {
			collapsed: false,
			sysUserName: '',
			sysUserAvatar: '',
			currentLanguage: localStorage.getItem('language') || 'zh-TW', // 当前语言，从本地存储获取或默认为繁体中文
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			menusPath: [],
		}
	},
	computed: {
		// 获取当前语言的文本
		currentTexts() {
			return {
				title: this.$t('pageTitle', 'home'),
				selectLanguage: this.$t('common', 'selectLanguage'),
				logout: this.$t('button', 'logout'),
				confirmLogout: this.$t('message', 'confirmLogout'),
				confirmTitle: this.$t('common', 'info'),
				languageSwitched: this.getLanguageSwitchedMessage()
			};
		},
		
		// 监听Vuex中的语言状态变化
		vuexLanguage() {
			return this.$store.state.currentLanguage;
		}
	},
	methods: {
		onSubmit() {
		},
		handleopen() {
		},
		handleclose() {
		},
		handleselect: function (a, b) {
			console.log(a, b);
		},
		//退出登录
		logout: function () {
			var _this = this;
			this.$confirm(this.currentTexts.confirmLogout, this.currentTexts.confirmTitle, {
				confirmButtonText: this.$t('button', 'confirm'),
				cancelButtonText: this.$t('button', 'cancel'),
				type: 'warning'
			}).then(() => {
				removeLocalStorage('user');
				removeCookie('token');
				_this.$router.push('/login');
			}).catch(() => {
			});
		},
		//折叠导航栏
		collapse: function () {
			this.collapsed = !this.collapsed;
		},
		showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		},
		getAllPath(arr = []) {
			return arr.map(val => {
				if (val.menuModelList && val.menuModelList.length) {
					this.getAllPath(val.menuModelList)
				}
				this.menusPath.push(val.page);
			});
		},
		// 获取菜单的多语言名称
		getMenuName(routeName) {
			// 菜单名称映射
			const menuNameMap = {
				'工作台': 'workbench',
				'用户管理': 'userManage',
				'企业管理': 'companyManage',
				'企业管理列表': 'companyManageList',
				'OEM管理': 'oemManage',
				'企业详情': 'companyDetail',
				'短视频管理': 'videoManage',
				'模块管理': 'moduleManage',
				'权限管理': 'permissionsManage',
				'操作记录': 'operationRecords',
				'企业服务': 'enterpriseService',
				'活动管理': 'activityManage',
				'订单管理': 'orderManage',
				'服务订单': 'serviceOrder',
				'访客数据': 'visitorData',
				'名片详情': 'cardDetail',
				'企业卡片': 'companyCard',
				'企业通知': 'companyNotice',
				'易脉智能卡片': 'yimaiSmartCard',
				'易脉CRM卡片': 'yimaiCrmCard',
				'小程序管理': 'wxappletManage',
				'小程序管理列表': 'wxappletManage',
				'代码管理': 'codeManage',
				'数据中心': 'dataCenter',
				'更新公告': 'updateAnnouncement',
				'睿哲智能名片': 'yimaiSmartCard',
				'睿哲智能CRM': 'yimaiCrmCard',
				'访客数据': 'visitorData',
				'发布活动': 'publishActivity',
				'编辑活动': 'editActivity',
				'购买详情': 'buyActivity',
				'订单详情': 'orderDetail',
				'小程序版本管理': 'versionManage'
			};
			
			const key = menuNameMap[routeName];
			if (key) {
				return this.$t('menu', key);
			}
			return routeName;
		},
		// 语言切换方法
		switchLanguage(language) {
			this.currentLanguage = language;
			
			// 使用Vuex更新全局语言状态
			this.$store.commit('SET_LANGUAGE', language);
			
			// 更新页面语言
			this.updatePageLanguage(language);
			
			// 显示切换成功的提示信息
			this.$message.success(this.getLanguageSwitchedMessage());
			
			// 强制更新组件，确保按钮文本更新
			this.$forceUpdate();
		},
		
		// 更新页面语言
		updatePageLanguage(language) {
			// 更新当前语言
			this.currentLanguage = language;
			
			// 强制更新组件，确保所有使用currentTexts的地方都会重新渲染
			this.$forceUpdate();
			
			// 通知全局语言管理器
			this.$i18n.setLanguage(language);
			
			// 更新页面标题
			document.title = this.$i18n.getText('pageTitle', 'home');
			
			// 更新Element UI的pagination组件语言
			this.$updateElementUILocale(language);
			
			// 触发全局事件，通知其他组件更新语言
			this.$root.$emit('language-changed', language);
			
			// 使用全局强制更新机制
			if (this.$forceUpdateAllComponents) {
				this.$forceUpdateAllComponents();
			}
			
			console.log('全局语言已切换到:', language);
		},
		

		
		// 获取语言切换提示消息
		getLanguageSwitchedMessage() {
			const messages = {
				'zh-CN': '已切换到简体中文',
				'zh-TW': '已切換到繁體中文',
				'en': 'Switched to English'
			};
			return messages[this.currentLanguage] || messages['zh-TW'];
		},
		
		// 获取当前语言的显示名称
		getCurrentLanguageDisplayName() {
			const languageNames = {
				'zh-CN': '简体中文',
				'zh-TW': '繁體中文',
				'en': 'English'
			};
			return languageNames[this.currentLanguage] || languageNames['zh-TW'];
		},
		
		// 初始化语言设置
		initLanguage() {
			// 从本地存储获取保存的语言设置
			const savedLanguage = localStorage.getItem('language');
			if (savedLanguage && ['zh-CN', 'zh-TW', 'en'].includes(savedLanguage)) {
				this.currentLanguage = savedLanguage;
				// 更新页面标题
				document.title = this.$i18n.getText('pageTitle', 'home');
				// 初始化Element UI的pagination语言
				this.$updateElementUILocale(savedLanguage);
			} else {
				// 如果没有保存的语言设置，使用默认语言
				this.currentLanguage = 'zh-TW';
			}
		},
	},
	mounted() {
		var user = getLocalStorage('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.companyName || '';
			this.sysUserAvatar = user.companyLogo || (serverUrl.imgUrl + 'one-www/photo/20190516/1557976316588.png');
		}
		this.getAllPath(user.list)
		
		// 初始化语言设置
		this.initLanguage();
		
		// 确保Vuex状态与组件状态同步
		if (this.currentLanguage !== this.$store.state.currentLanguage) {
			this.$store.commit('SET_LANGUAGE', this.currentLanguage);
		}
	},
	
	watch: {
		// 监听Vuex中的语言状态变化
		vuexLanguage(newLanguage) {
			if (this.currentLanguage !== newLanguage) {
				this.currentLanguage = newLanguage;
			}
		}
	},
}
</script>

<style scoped lang="scss">
@import '~scss_vars';

.container {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;

	.header {
		height: 60px;
		line-height: 60px;
		background: $color-primary;
		color: #fff;
		border-bottom: 1px solid #ddd;

		.userinfo {
			text-align: right;
			padding-right: 35px;
			float: right;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.header-dropdown {
				margin-right: 15px;
				
				.header-btn {
					color: #000;
					opacity: 0.7;
					font-size: 14px;
					padding: 8px 12px;
					border-radius: 4px;
					transition: all 0.3s ease;
					
					&:hover {
						opacity: 1;
						color: #51CDCB;
						background-color: rgba(81, 205, 203, 0.1);
					}
					
					i {
						margin-right: 5px;
					}
				}
			}

			.userinfo-inner {
				cursor: pointer;
				color: #000;
				opacity: 0.7;

				img {
					width: 40px;
					height: 40px;
					border-radius: 20px;
					margin: 10px 0px 10px 10px;
					float: right;
				}
			}
		}

		.logo {
			//width:230px;
			height: 60px;
			font-size: 22px;
			padding-left: 20px;
			padding-right: 20px;
			border-color: rgba(238, 241, 146, 0.3);
			border-right-width: 1px;
			border-right-style: solid;

			.logo-img {
				height: 45px;

				img {
					width: 30px;
					height: 30px;
					position: relative;
					top: 8px;
				}

				h1 {
					font-size: 18px;
					color: #51CDCB;
					cursor: pointer;
					font-family: "Microsoft YaHei UI";
					display: inline-block;
					line-height: 30px;
					margin: 0;
					margin-left: 6px;
				}
			}
		}

		.logo-width {
			width: 230px;
		}

		.logo-collapse-width {
			width: 60px
		}

		.tools {
			padding: 0px 23px;
			width: 14px;
			height: 60px;
			line-height: 60px;
			cursor: pointer;
			color: #000;
			opacity: 0.7;
		}
	}

	.main {
		display: flex;
		// background: #324057;
		position: absolute;
		top: 60px;
		bottom: 0px;
		overflow: hidden;

		aside {
			flex: 0 0 230px;
			width: 230px;

			// position: absolute;
			// top: 0px;
			// bottom: 0px;
			.el-menu {
				height: 100%;
			}

			.collapsed {
				width: 60px;

				.item {
					position: relative;
				}

				.submenu {
					position: absolute;
					top: 0px;
					left: 60px;
					z-index: 99999;
					height: auto;
					display: none;
				}

			}
		}

		.menu-collapsed {
			flex: 0 0 60px;
			width: 60px;

			.el-menu-vertical-demo {
				background: #fff;
			}
		}

		.menu-expanded {
			flex: 0 0 230px;
			width: 230px;

			.el-menu-vertical-demo {
				width: 100% !important;
				background: #fff;
			}
		}

		.content-container {
			background-color: #f6f9fa;
			flex: 1;
			// position: absolute;
			// right: 0px;
			// top: 0px;
			// bottom: 0px;
			// left: 230px;
			overflow-y: scroll;
			padding: 20px;

			.breadcrumb-container {

				//margin-bottom: 15px;
				.title {
					color: #51CDCB;
					font-size: 21px;
				}

				.breadcrumb-inner {
					margin-top: 10px;
				}
			}

			.content-wrapper {
				box-sizing: border-box;
				padding: 10px;
				min-height: calc(100vh - 150px);
				// background: #fff;
			}
		}
	}

	.el-menu-item.is-active {
		color: #51cdcb !important;
	}
	
	// 语言选择下拉菜单样式
	.el-dropdown-menu {
		.el-dropdown-item.is-active {
			color: #51cdcb !important;
			background-color: #f0f9ff;
			font-weight: 500;
			
			i {
				color: #51cdcb;
				margin-right: 8px;
			}
		}
		
		.el-dropdown-item {
			padding: 10px 20px;
			transition: all 0.2s ease;
			
			&:hover {
				background-color: #f5f7fa;
				color: #51cdcb;
			}
			
			i {
				margin-right: 8px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// Home.vue?2e820a18